const minin = {
  data() {
    return {
      form: {
        carstatus: '在用',
      },
      showLicense: false,
      licenseCtrl: {
        label: "车牌号",
        keyName: "license",
        type: "text",
        viewMode: true,
      },
      formCtrl: [
        {
          label: "挂车号",
          keyName: "trailer",
          err: "请填写挂车号",
          type: "text",
          className: "instyle",
        },

        {
          label: "车辆状态",
          keyName: "carstatus",
          type: "select",
          options: [
            {
              label: "在用",
              value: "在用"
            },
            {
              label: "停用",
              value: "停用"
            },
            {
              label: "报废",
              value: "报废"
            },
            {
              label: "已卖",
              value: "已卖"
            },
          ],
          className: "instyle",
        },
        {
          label: "核定载重(吨)",
          keyName: "ton",
          err: "请填写核定载重",
          type: "number",
          className: "instyle",
        },
        {
          label: "购入时间",
          keyName: "buytime",
          err: "请选择时间",
          type: "date",
          className: "instyle",
        },
        {
          label: "品牌",
          keyName: "brand",
          err: "请填写品牌",
          type: "text",
          className: "instyle",
        },
        {
          label: "车辆照片",
          keyName: "car_image",
          type: "file",
          ptype: "car",
          tips: "最多上传10张图片",
          max: 10,
        },
      ],
    };
  },
  methods: {
    setOptions({ carstatus }) {
      this.formCtrl.map((c) => {
        if (c.keyName == "carstatus" && carstatus && carstatus.length) {
          c.options = carstatus.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          if (!this.form.license) this.form.carstatus = carstatus[0].name;
        }
      });
      this.$forceUpdate();
    },
    setDetail() {
      // 获取第一个表单所有字段名
      const keys = this.formCtrl.map(v => {
        return v.keyName
      })

      keys.map(key => {
        const value = this.detail[key]
        if (['fleet'].includes(key)) {
          // this.form[key] = value + '';
        } else {
          this.form[key] = value;
        }
      })

      this.form['license'] = this.detail['license']

      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
  },
  created() {
    if (this.$route.fullPath.includes('?')) {
      this.showLicense = true
    }
  },
  mounted() {
    this.getOptions();
  },
}

export default minin